export default __webpack_public_path__ + "static/media/q6.0b99ff04.svg";